(function($) {

  $(document).ready(function() {

      var xmlHttp;
      function srvTime(){
        try {
          //FF, Opera, Safari, Chrome
          xmlHttp = new XMLHttpRequest();
        }
        catch (err1) {
          //IE
          try {
            xmlHttp = new ActiveXObject('Msxml2.XMLHTTP');
          }
          catch (err2) {
            try {
              xmlHttp = new ActiveXObject('Microsoft.XMLHTTP');
            }
            catch (eerr3) {
              //AJAX not supported, use CPU time.
              alert("AJAX not supported");
            }
          }
        }
        xmlHttp.open('HEAD',window.location.href.toString(),false);
        xmlHttp.setRequestHeader("Content-Type", "text/html");
        xmlHttp.send('');
        return xmlHttp.getResponseHeader("Date");
      }

      $('.tab-switcher').on('click keypress', function (event) {

          if ( $(this).hasClass('active') ) {
            return false;
          }

          var tabClicked = $(this).data("tab-index");

          $('.tab-switcher').removeClass('active');
          $(this).addClass('active');

          if ( (event.type === "keypress" && event.which === 13) || event.type === "click" ) {
            $('.tabs-container--tab.active').fadeOut(200, function() {
              $('.tabs-container--tab.active').removeClass('active');
              $('.tabs-container--tab[data-tab-index="' + tabClicked + '"]').addClass('active').fadeIn(200);
            });
          }
      });

      $('#toggle-past').on('click', function (event) {

          var st = srvTime();
          var timestamp = + new Date(st)/1000;

          $(this).text(function(i, text){
              return text === "Näytä menneet" ? "Piilota menneet" : "Näytä menneet";
          });

          event.preventDefault();

          $('.this-day-tab .schedule__item').not('.schedule__item--last').each(function(){
            $stamp = $(this).data('time');
            if ( $stamp < timestamp ) {
              $(this).toggleClass('past-item');
            } else {
              return false;
            }
          });

      });

      $('.past-day').on('click', function (event) {

          event.preventDefault();

          $('#toggle-past').fadeOut();

      });

      $('.this-day').on('click', function (event) {

          event.preventDefault();

          $('#toggle-past').fadeIn();

      });

      $('.future-day').on('click', function (event) {

          event.preventDefault();

          $('#toggle-past').fadeOut();

      });

  });

})(jQuery);

